module.exports = __webpack_public_path__ + "static/media/lateral-nonflexion-up-2.dbb34a05.png";